import { createAPI } from '../http'
import axios from "axios";
import { API_SVC_HOST } from '../../config/common';
axios.create({
    baseURL: API_SVC_HOST
});
const api = createAPI();

/**
 * 供应链api
 */

export function get_my_supply_chain_v3(params) {
	/**查询我的供应链 */
	return api.get('/api/supply_chain', params)
}

export function get_my_supply_chain_detail_v3(id) {
	/**查询我的供应链明细 */
	return api.get(`/api/supply_chain/${id}`)
}

export function put_my_supply_chain_v3(id, params) {
	/**修改我的供应链 */
	return api.put(`/api/supply_chain/${id}`, params)
}
export function post_my_supply_chain_v3(params) {
	/**提交我的供应链 */
	return api.post(`/api/supply_chain`, params)
}

export function put_my_supply_chain_status_v3(id, params) {
	/**修改供应链状态 */
	return api.put(`/api/supply_chain_status/${id}`, params)
}

export function delete_my_supply_chain_v3(id) {
	/**删除我的供应链 */
	return api.delete(`/api/supply_chain/${id}`)
}
export function getCompanyNameList(params) {
	/**供应链企业列表 */
	return api.get(`/api/supply_chain_user`, params)
}

export function getCompanyRoleList() {
	/**供应链角色 */
	return api.get(`/api/public/supply_chain_role`)
}

export function getMySuppliChainList(params) {
	/**我的供应链列表 */
	return api.get(`/api/user_supply_chain`, params)
}